export const DisclaimerDeviceShortTerm: string[] = [
  "The monthly cost is invoiced monthly in advance.",
];
